import { FC } from "react";
import { TabSelectionItem } from "./nestedTableTabOptions";
import { NestedTableTabButton, NestedTableTabSelectionColumn } from "./tableComponents";
import { useTheme } from "../../../features/context/CustomerContext";
import useCustomTranslation from "../../../features/hooks/CustomUseTranslation";

interface NestedTableTabSelectionProps {
    tabs: TabSelectionItem[]
    handleTabChange: (selectedTab: string) => void;
    activeTab: string
}

const NestedTableTabSelection:FC<NestedTableTabSelectionProps> = (props) => {
    const { t } = useCustomTranslation();
    const theme = useTheme();
    return(
        <NestedTableTabSelectionColumn>
            {props.tabs.map((tab, index) => (
                <NestedTableTabButton customerTheme={theme} theme={{active: tab.tabName === props.activeTab}} key={index} onClick={() => props.handleTabChange(tab.tabName)}>{t(tab.tabLabel)}</NestedTableTabButton>
            ))}
        </NestedTableTabSelectionColumn>
    );
}

export default NestedTableTabSelection;